<template>
  <slot v-if="pending && !showDataStateEvenWhenLoading" name="pending">
    <NamiLoading />
  </slot>
  <slot v-else-if="error" name="error" :error="error" :retry="() => refresh()">
    <Error :error="error" @retry="() => refresh()" />
  </slot>
  <slot v-else :data="data" :attrs="$attrs"></slot>
</template>

<script setup lang="ts" generic="T">
defineComponent({
  inheritAttrs: false,
});

defineProps<{
  data: T;
  pending: boolean;
  error: any;
  refresh: () => any;
  showDataStateEvenWhenLoading?: boolean;
}>();
</script>
